import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, TextField, Typography } from '@mui/material';
import { IoClose } from "react-icons/io5";
import { useEffect } from 'react';


export default function ConfirmationDialog(props) {
  
console.log("props",props);

useEffect(()=>{
  if(!props.open){
    props.setRemarks("")
  }
},[props.open])

  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        maxWidth="xs"
        fullWidth
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant='h4'>Remarks</Typography>
        </DialogTitle>
        <DialogContent>
            <Box sx={{position:'absolute',top:5,right:5,cursor:'pointer',fontSize:'22px'}} onClick={props.handleClose}>
            <IoClose />

            </Box>
          <DialogContentText id="alert-dialog-description" sx={{padding:1}}>
            <TextField 
                id="outlined-basic" 
                fullWidth
                value={props.remarks?props.remarks:""}
                onChange={(e)=>props.setRemarks(e.target.value)} 
                variant="outlined" />
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{display:'flex',justifyContent:'center'}}>
          
          <Button disabled={props.IsLoading} variant='contained' color='secondary' onClick={props.handleSubmit} >
            {props.IsLoading?"Loading...":"SUBMIT"}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
